var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as MainStaticPageFactory from "../../classes/definitions/mainStaticPage/mainStaticPage";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import MainStaticPagesList from '../../components/MainStaticPages/MainStaticPagesList/MainStaticPagesList';
import AppRoutes from '../../config/appRoutes';
import MainStaticPagesReduxProps from "./MainStaticPagesReduxProps";
var MainStaticPages = /** @class */ (function (_super) {
    __extends(MainStaticPages, _super);
    function MainStaticPages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllMainStaticPages = function () {
            _this.api.getMainStaticPages()
                .then(function (response) {
                var mainStaticPages = MainStaticPageFactory.createMainStaticPages(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: mainStaticPages, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим статичната страница', _this.props.history);
            });
        };
        _this.toNewMainStaticPage = function () {
            _this.props.history.push(AppRoutes.staticPage.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    MainStaticPages.prototype.componentDidMount = function () {
        this.getAllMainStaticPages();
        console.log('process.env.REACT_APP_PUBLIC_DOMAIN', process.env.REACT_APP_PUBLIC_DOMAIN);
    };
    MainStaticPages.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0421\u0442\u0430\u0442\u0438\u0447\u043D\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewMainStaticPage, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u0430 \u0441\u0442\u0430\u0442\u0438\u0447\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(MainStaticPagesList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return MainStaticPages;
}(React.Component));
export default connect(null, MainStaticPagesReduxProps.mapDispatchToProps)(MainStaticPages);



//////////////////
// WEBPACK FOOTER
// ./src/views/MainStaticPages/MainStaticPages.tsx
// module id = 371
// module chunks = 0